import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const MantenimientoPreventivo = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/ingenieria-mantenimiento-preventivo-total.pdf`;
  /*const pdfUrl = "/pdf/ingenieria-mantenimiento-preventivo-total.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Mantenimiento Preventivo</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Mantenimiento Preventivo" />
      </Container>
    </>
  );
};

 export default MantenimientoPreventivo;
